import { useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { useSelector } from "react-redux";
import { handleError } from "../../helpers/handleError";
import { changePasswordApi } from "../../api/api";
import "./profile.css";
import { useNavigate } from "react-router-dom";
import Eye from "../../assets/Eye.svg";
import EyeOff from "../../assets/Eyeoff.svg";

const AccountPassword = () => {
  const accessToken = useSelector((s) => s.auth.accessToken);
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [saving, setSaving] = useState(false);
  const [savedMsg, setSavedMsg] = useState("");
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const pw = form.next || "";
  const pwHasUpper = /[A-Z]/.test(pw);
  const pwHasLower = /[a-z]/.test(pw);
  const pwHasNumber = /\d/.test(pw);
  const pwHasSpecial = /[^A-Za-z0-9]/.test(pw);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSavedMsg("");
    if (!form.next || form.next.length < 8) {
      window.alert("La contraseña nueva debe tener al menos 8 caracteres");
      return;
    }
    if (!(pwHasUpper && pwHasLower && pwHasNumber && pwHasSpecial)) {
      window.alert("La contraseña debe contener mayúscula, minúscula, número y carácter especial");
      return;
    }
    if (form.next !== form.confirm) {
      window.alert("Las contraseñas no coinciden");
      return;
    }
    try {
      setSaving(true);
      const res = await changePasswordApi(accessToken, {
        currentPassword: form.current,
        newPassword: form.next,
      });
      if (res?.status === 200) {
        setForm({ current: "", next: "", confirm: "" });
        setSavedMsg("Contraseña actualizada");
      }
    } catch (error) {
      handleError(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="cardDatosPersonales">
        <div className="profile-title">Cambiar contraseña</div>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="current">
            <Form.Label>Contraseña actual</Form.Label>
            <InputGroup className="profile-password-group">
              <Form.Control
                className="correo profile-password-input"
                type={showCurrentPassword ? "text" : "password"}
                placeholder="********"
                value={form.current}
                onChange={(e) => setForm({ ...form, current: e.target.value })}
                required
              />
              <button
                type="button"
                className="profile-eye"
                onClick={() => setShowCurrentPassword((prev) => !prev)}
                onMouseDown={(e) => e.preventDefault()}
                aria-label={showCurrentPassword ? "Ocultar contraseña actual" : "Mostrar contraseña actual"}
              >
                <img src={showCurrentPassword ? EyeOff : Eye} alt="" width={20} height={20} />
              </button>
            </InputGroup>
          </Form.Group>

          <Form.Group className="mb-3" controlId="next">
            <Form.Label>Contraseña nueva</Form.Label>
            <InputGroup className="profile-password-group">
              <Form.Control
                className="correo profile-password-input"
                type={showNewPassword ? "text" : "password"}
                placeholder="Mínimo 8 caracteres"
                value={form.next}
                onFocus={() => setPasswordFocused(true)}
                onBlur={() => setPasswordFocused(false)}
                onChange={(e) => setForm({ ...form, next: e.target.value })}
                required
              />
              <button
                type="button"
                className="profile-eye"
                onClick={() => setShowNewPassword((prev) => !prev)}
                onMouseDown={(e) => e.preventDefault()}
                aria-label={showNewPassword ? "Ocultar contraseña nueva" : "Mostrar contraseña nueva"}
              >
                <img src={showNewPassword ? EyeOff : Eye} alt="" width={20} height={20} />
              </button>
            </InputGroup>
            {passwordFocused && (
              <div className="password-conditions" aria-live="polite">
                <span className={`cond-item ${pwHasUpper ? 'ok' : ''}`}>Mayuscula</span>
                <span className={`cond-item ${pwHasLower ? 'ok' : ''}`}>Minuscula</span>
                <span className={`cond-item ${pwHasNumber ? 'ok' : ''}`}>Numero</span>
                <span className={`cond-item ${pwHasSpecial ? 'ok' : ''}`}>Caracter especial</span>
              </div>
            )}
          </Form.Group>

          <Form.Group className="mb-4" controlId="confirm">
            <Form.Label>Repetir contraseña</Form.Label>
            <InputGroup className="profile-password-group">
              <Form.Control
                className="correo profile-password-input"
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Repite tu contraseña"
                value={form.confirm}
                onChange={(e) => setForm({ ...form, confirm: e.target.value })}
                required
              />
              <button
                type="button"
                className="profile-eye"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                onMouseDown={(e) => e.preventDefault()}
                aria-label={showConfirmPassword ? "Ocultar confirmación de contraseña" : "Mostrar confirmación de contraseña"}
              >
                <img src={showConfirmPassword ? EyeOff : Eye} alt="" width={20} height={20} />
              </button>
            </InputGroup>
          </Form.Group>

          <div className="profile-actions">
            <Button type="submit" className="success" disabled={saving}>
              {saving ? "Guardando..." : "Guardar cambios"}
            </Button>
            {savedMsg && <span className="profile-saved">{savedMsg}</span>}
          </div>
          <div className="profile-back" onClick={() => navigate('/event')}>
            <span className="profile-back-arrow">‹</span> Volver a <span className="profile-back-link">Eventos</span>
          </div>
        </Form>
      </div>
    </>
  );
};

export default AccountPassword;
